module.exports = __webpack_public_path__ + "img/save.9b9949d5.svg";